let btn = document.getElementById("tooltip-toggleBtn");
let content = document.getElementById("tooltip-content");


function showToggletip() {
    btn.setAttribute("aria-expanded", "true"); 
    content.classList.add("active");
}

function hideToggletip() {
    btn.setAttribute("aria-expanded", "false");
    content.classList.remove("active");
}

function toggleTooltip (e) {
  if (!content.classList.contains('active')) { 
    showToggletip();
  } else {
    hideToggletip();    
  }
}

btn.addEventListener("click", toggleTooltip, false);

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 27 || e.keyCode === 17) {
  toggleTooltip();
    }
});

btn.addEventListener("click", toggleTooltip);